import {React, styled} from 'common'
import {Controller} from 'react-hook-form'
import {FormErrorText} from 'components/Control/Form'
import Input from '../Input'
import {useI18n} from 'store/Store'

const FormTextInput = ({
    name,
    label,
    control,
    errors,
    rules,
    required,
    disabled,
    fullWidth,
    type,
    initialValue = ' ',
}) => {
    const {i18n} = useI18n()

    return (
        <Container>
            <Controller
                name={name}
                control={control}
                rules={rules || {required}}
                render={({field: {onChange, value}}) => (
                    <Input
                        onChange={onChange}
                        value={value || initialValue}
                        fullWidth={fullWidth}
                        label={label ?? name}
                        required={required}
                        disabled={disabled}
                        type={type}
                    />
                )}
            />
            {errors?.[name] && (
                <FormErrorText>
                    {i18n.t('welcome.invalidInput', {input: label})}
                </FormErrorText>
            )}
        </Container>
    )
}

export default FormTextInput

const Container = styled.div`
    margin-top: 20px;
    margin-bottom: 10px;
    width: 100%;
`
